import getCustomerBillingPortal from 'api/v1/subscriptions/getCustomerBillingPortal';
import useMutation from 'hooks/react-query/useMutation';

const useRedirectToCustomerBillingPortal = () => {
  return useMutation(getCustomerBillingPortal, {
    onSuccess: ({ url }) => {
      window.location.href = url;

      return new Promise(() => {});
    },
  });
};

export default useRedirectToCustomerBillingPortal;
